import { DialogProps } from "@/types/ui";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import NewStoreForm, { NewStoreFormData } from "./new-store-form";
import { Button } from "@/components/ui/button";
import { useForm } from "@inertiajs/react";
import { Spinner } from "@/components/ui/spinner";
import useTranslations from "@/hooks/use-translations";

export default function NewStoreDialog({ open, onOpenChange }: DialogProps) {
  const { t } = useTranslations("shared.components.new_store_dialog");
  const form = useForm<NewStoreFormData>({
    store: {
      name: "",
      subdomain: "",
      currency: "usd",
    },
  });

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("title")}</DialogTitle>
        </DialogHeader>

        <NewStoreForm form={form} onSubmitForm={() => onOpenChange(false)} />

        <DialogFooter>
          <Button
            type="submit"
            className="w-full"
            form="new-store-form"
            disabled={form.processing}
          >
            {form.processing && <Spinner />}
            {t("submit")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
